import { useEffect, useState } from 'react';
import { DevelopersService } from '../api';
import { useAppState } from '../state/appstate/appstate';

export function useProductName(): string {
  const appState = useAppState();
  const [styleName, setStyleName] = useState("");

  useEffect(() => {
    (async () => {
      const style = (
        await DevelopersService.getStylesForProduct(
          appState.styleProduct.product!.id
        )
      ).find((v) => v.id === appState.styleProduct.style!.id);

      setStyleName(style!.title);
    })();
  }, [appState.styleProduct.product?.id]);

  return styleName;
}
